export default __webpack_public_path__ + "static/StoreImage-d98587030376c5ae5d2e0a7689f332ce.jpg";